import React from 'react';
import { Link } from 'react-router-dom';
import blogPosts from '../data/blogPosts';

const BlogPreview = () => {
  // Sort by date descending so the newest posts always appear first
  const previewPosts = [...blogPosts]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 2);

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="text-primary font-bold tracking-widest uppercase text-sm mb-4 block">
            From Our Blog
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Moving Tips & Insights
          </h2>
          <p className="text-gray-600 text-lg md:text-xl leading-relaxed">
            Expert guides, real stories, and everything you need to plan a
            stress-free move.
          </p>
        </div>

        {/* Two Featured Blog Cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {previewPosts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="group block"
            >
              <article className="bg-gray-50 rounded-3xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-[0_15px_40px_rgb(0,0,0,0.08)] transition-all duration-500 hover:-translate-y-1 h-full flex flex-col">
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute top-4 left-4 flex gap-2">
                    <span className="bg-primary text-white text-[10px] px-3 py-1 rounded-full font-bold uppercase tracking-wider">
                      {post.category}
                    </span>
                    <span className="bg-white/90 backdrop-blur-sm text-gray-600 text-[10px] px-3 py-1 rounded-full font-bold uppercase tracking-wider">
                      {post.readTime}
                    </span>
                  </div>
                </div>
                <div className="p-7 flex flex-col flex-grow">
                  <p className="text-gray-400 text-sm mb-3">{post.date}</p>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors duration-300 leading-snug">
                    {post.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed mb-5 flex-grow line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center text-primary font-semibold text-sm mt-auto">
                    Read Full Article
                    <svg
                      className="w-4 h-4 ml-2 group-hover:translate-x-2 transition-transform duration-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                      />
                    </svg>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center">
          <Link
            to="/blog"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-gray-900 to-gray-800 hover:from-gray-800 hover:to-gray-700 text-white px-8 py-4 rounded-full font-semibold text-base transition-all duration-300 shadow-[0_10px_40px_-10px_rgba(0,0,0,0.3)] hover:shadow-[0_20px_50px_-10px_rgba(0,0,0,0.4)] hover:-translate-y-0.5"
          >
            View All Blog Posts
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
